import { DialogContentText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React, { useRef, useState } from 'react';
import colors from '../../styles/settings/colors';
import * as S from './styles';

export function PasswordBox({ textBody, callback, open }) {
  const searchInput = useRef(null);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const currentlyMessage = {
    mensagemBoxUnidade: 'px',
    tituloTexto: '<strong>TITULO - 93</strong>',
    tituloCorDeFundo: '#232D64',
    tituloCorDaFonte: '#FFFFFF',
    tituloTamanhoDaFonte: 14,
    tituloBoxAltura: 0,
    mensagemTextoAlinhamento: 'Left',
    mensagemCorDeFundo: '#FFFFFF',
    mensagemCorDaFonte: '#000000',
    mensagemTamanhoDaFonte: 16,
    mensagemBoxAltura: 0,
    mensagemBoxLargura: 611,
    barraBotoesCorDeFundo: '#FFFFFF',
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setIsRedirecting(true);
    callback();
    setTimeout(() => {
      setIsRedirecting(false);
    }, 5000);
  };

  return (
    <S.DialogModal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      className="dialog-parent"
      widthContainer={currentlyMessage?.mensagemBoxLargura}
    >
      <S.DialogContainer borderColor={currentlyMessage?.tituloCorDeFundo}>
        <div className="margin-container">
          <S.Title
            bgColor={currentlyMessage?.tituloCorDeFundo}
            color={currentlyMessage?.tituloCorDaFonte}
            heightTitle={currentlyMessage?.TituloBoxAltura}
            style={{
              height: `${
                currentlyMessage?.tituloBoxAltura > 0
                  ? `${currentlyMessage?.tituloBoxAltura}${currentlyMessage?.mensagemBoxUnidade}`
                  : 'auto'
              }`,
            }}
            fontTitle={currentlyMessage?.tituloTamanhoDaFonte}
          >
            <span>Alteração de senha</span>
          </S.Title>

          <S.BodyText
            bgColor={currentlyMessage?.mensagemCorDeFundo}
            color={currentlyMessage?.mensagemCorDaFonte}
            messageFontSize={currentlyMessage?.mensagemTamanhoDaFonte}
            style={{
              height: `${
                currentlyMessage?.mensagemBoxAltura > 0
                  ? `${currentlyMessage?.mensagemBoxAltura}${currentlyMessage?.mensagemBoxUnidade}`
                  : 'auto'
              }`,
            }}
          >
            <DialogContentText>
              <div
                className="message-html"
                dangerouslySetInnerHTML={{ __html: textBody }}
                style={{
                  textAlign: currentlyMessage?.mensagemTextoAlinhamento?.toLowerCase(),
                }}
              ></div>
            </DialogContentText>
          </S.BodyText>

          <S.DialogActionsMessage backgroundColor={currentlyMessage.barraBotoesCorDeFundo}>
            <Button
              onClick={handleClose}
              autoFocus
              disabled={isRedirecting}
              focusVisible
              ref={searchInput}
              style={{
                color: '#fff',
                backgroundColor: colors.sanMarino,
                textTransform: 'initial',
                fontWeight: '400',
              }}
            >
              {isRedirecting ? 'Redirecionando...' : 'CIENTE'}
            </Button>
          </S.DialogActionsMessage>
        </div>
      </S.DialogContainer>
    </S.DialogModal>
  );
}
